import { Constants } from '../constants';
import { MAX_BLACK_DICE, MAX_MORTAL_DICE, MAX_RED_DICE, MAX_WHITE_DICE } from '../constants/constants';
import { LoadoutStats, PowerDie, PowerDieColor, PowerDieCount } from '../types';
import { shallowCopy } from './data-replication';

export function getPowerDiceColors(
    stats: LoadoutStats,
    numHits: number,
    disableDiceLimits: boolean = false,
): PowerDieColor[] {
    let diceToRoll = stats.overridePowerDice
        ? stats.perHitPowerDiceOverride.at(numHits - 1)!.flat()
        : Array(numHits).fill(stats.perHitPowerDice).flat();
    diceToRoll = diceToRoll.concat(stats.powerDice);

    let diceCounts = {
        red: diceToRoll.filter((die) => die === 'Red').length,
        black: diceToRoll.filter((die) => die === 'Black').length,
        white: diceToRoll.filter((die) => die === 'White').length,
        mortal: diceToRoll.filter((die) => die === 'Mortal').length,
    };
    if (!disableDiceLimits) {
        diceCounts = applyDiceLimits(diceCounts);
    }

    return [
        ...Array(diceCounts.red).fill('Red'),
        ...Array(diceCounts.black).fill('Black'),
        ...Array(diceCounts.white).fill('White'),
        ...Array(diceCounts.mortal).fill('Mortal'),
    ];
}

export function getPowerDice(colors: PowerDieColor[]): PowerDie[] {
    return colors.map((color) => getPowerDie(color));
}

/**
 * PRIVATE
 */

function getPowerDie(color: PowerDieColor): PowerDie {
    switch (color) {
        case PowerDieColor.RED:
            return shallowCopy(Constants.RED_POWER_DIE);
        case PowerDieColor.BLACK:
            return shallowCopy(Constants.BLACK_POWER_DIE);
        case PowerDieColor.WHITE:
            return shallowCopy(Constants.WHITE_POWER_DIE);
        case PowerDieColor.MORTAL:
            return shallowCopy(Constants.MORTAL_POWER_DIE);
        default:
            throw new Error(`Unsupported power die color: ${color}`);
    }
}

function applyDiceLimits(diceCounts: PowerDieCount): PowerDieCount {
    while (diceCounts.red > MAX_RED_DICE) swapDice(diceCounts, 'red', 'black', 2, 1);
    while (diceCounts.black > MAX_BLACK_DICE) swapDice(diceCounts, 'black', 'white', 2, 1);
    while (diceCounts.white > MAX_WHITE_DICE) swapDice(diceCounts, 'white', 'black', 1, 2);
    while (diceCounts.black > MAX_BLACK_DICE) swapDice(diceCounts, 'black', 'red', 1, 2);
    diceCounts.red = Math.min(diceCounts.red, MAX_RED_DICE);
    while (diceCounts.mortal > MAX_MORTAL_DICE) swapDice(diceCounts, 'mortal', 'white', 2, 1);
    return diceCounts;
}

function swapDice(diceCounts: any, from: string, to: string, fromQty: number, toQty: number) {
    diceCounts[from] -= fromQty;
    diceCounts[to] += toQty;
}
